import { jsxs, jsx } from 'react/jsx-runtime';
import { cssRadixPopoverContentOverride } from '../Drawer/cssRadixPopoverOverride.js';
import { Drawer } from '../Drawer/Drawer.js';
import { Content, SubContent } from '@radix-ui/react-context-menu';
import React__default from 'react';
import { keyframes, styled, css } from 'styled-components';
import { ScrollArea } from '../ScrollArea.js';

const fadeScaleIn = keyframes([
  `from{opacity:0;transform:translateX(-50%) scale(0.2);}to{opacity:1;transform:translateX(-50%) scale(1);}`
]);
const fadeScaleOut = keyframes([
  `from{opacity:1;transform:translateX(-50%) scale(1);}to{opacity:0;transform:translateX(-50%) scale(0.2);}`
]);
const ContextMenuPreviewAnchorContainer = styled.div.withConfig({
  displayName: "ContextMenuContentMobile__ContextMenuPreviewAnchorContainer",
  componentId: "sc-1f652a25-0"
})([
  `width:47vw;height:47vw;position:fixed;top:auto;bottom:calc(100dvh - 47dvw - 50px - env(safe-area-inset-top));left:50%;transform:translateX(-50%);will-change:scale,opacity,transform;pointer-events:none !important;opacity:0;`
]);
const ContextMenuPreviewAnchorContainerInner = styled.div.withConfig({
  displayName: "ContextMenuContentMobile__ContextMenuPreviewAnchorContainerInner",
  componentId: "sc-1f652a25-1"
})([
  `height:100%;width:100%;transition:0.1s opacity;& > *{max-width:none !important;max-height:none !important;height:100% !important;}`
]);
const StyledDrawer = styled(Drawer).withConfig({
  displayName: "ContextMenuContentMobile__StyledDrawer",
  componentId: "sc-1f652a25-2"
})([
  `padding-top:0;padding-bottom:0;padding-left:1rem;padding-right:1rem;`
]);
const cssContent = css([
  `font-size:0.9375rem;`,
  `;div:has(> &){inset:0 !important;transform:translateY(0px) !important;}&[data-state='open']{`,
  `{animation:`,
  ` 0.2s ease-out forwards !important;animation-delay:0.1s !important;}}&[data-state='closed']{transform:translateY(0px) !important;opacity:1 !important;animation:none !important;`,
  `{animation:`,
  ` 0.2s ease-out forwards !important;}}`
], cssRadixPopoverContentOverride, ContextMenuPreviewAnchorContainer, fadeScaleIn, ContextMenuPreviewAnchorContainer, fadeScaleOut);
const ContextMenuContentMobileBase = styled(Content).withConfig({
  displayName: "ContextMenuContentMobile__ContextMenuContentMobileBase",
  componentId: "sc-1f652a25-3"
})([
  ``,
  `;`
], cssContent);
const ContextMenuSubcontentContentMobileBase = styled(SubContent).withConfig({
  displayName: "ContextMenuContentMobile__ContextMenuSubcontentContentMobileBase",
  componentId: "sc-1f652a25-4"
})([
  ``,
  `;`
], cssContent);
const MobileContentInner = styled.div.withConfig({
  displayName: "ContextMenuContentMobile__MobileContentInner",
  componentId: "sc-1f652a25-5"
})([
  `display:flex;flex-direction:column;overflow:hidden;min-height:1px;padding-top:1rem;overflow:hidden;padding-bottom:calc(1rem + env(safe-area-inset-bottom));`
]);
const StyledScrollArea = styled(ScrollArea.Default).withConfig({
  displayName: "ContextMenuContentMobile__StyledScrollArea",
  componentId: "sc-1f652a25-6"
})([
  `display:flex;flex-direction:column;max-height:calc(100dvh - 47dvw - env(safe-area-inset-top) - 100px);border-radius:1rem 1rem 0 0;`
]);
const ContextMenuContentMobile = /* @__PURE__ */ React__default.forwardRef(function DropdownContentMobile({ children, onOpenChange, previewAnchor, isSubcontent }, ref) {
  const [drawerOffsetY, setDrawerOffsetY] = React__default.useState(0);
  const drawScale = Math.min(1 - Math.min(Math.min(Math.abs(drawerOffsetY), 400) / 400 - 0.1, 1), 1);
  const onPanEnd = React__default.useCallback((e, i, moreInfo) => {
    if (!moreInfo.shouldClose) {
      setDrawerOffsetY(0);
    }
  }, []);
  const Component = isSubcontent ? ContextMenuSubcontentContentMobileBase : ContextMenuContentMobileBase;
  return /* @__PURE__ */ jsxs(Component, {
    ref,
    children: [
      previewAnchor && /* @__PURE__ */ jsx(ContextMenuPreviewAnchorContainer, {
        "data-contextmenu-preview": true,
        children: /* @__PURE__ */ jsx(ContextMenuPreviewAnchorContainerInner, {
          // animation opacity is applied on parent with forward so we need to set another opacity controls on the inner
          style: {
            opacity: drawScale,
            transform: `scale(${drawScale})`
          },
          children: previewAnchor
        })
      }),
      /* @__PURE__ */ jsx(StyledDrawer, {
        onPanEnd,
        onOpenChange,
        onOffsetYChange: (value) => {
          if (value > 0) {
            setDrawerOffsetY(value);
          }
        },
        children: /* @__PURE__ */ jsx(StyledScrollArea, {
          innerDisplayFlex: true,
          "data-pan-id-ignore-context-menu": "y",
          scrollbarVariant: "none",
          children: /* @__PURE__ */ jsx(MobileContentInner, {
            children
          })
        })
      })
    ]
  });
});
const ContextMenuSubContentContentMobile = styled(ContextMenuContentMobile).attrs({
  isSubcontent: true
}).withConfig({
  displayName: "ContextMenuContentMobile__ContextMenuSubContentContentMobile",
  componentId: "sc-1f652a25-7"
})([
  ``
]);

export { ContextMenuContentMobile, ContextMenuSubContentContentMobile };
//# sourceMappingURL=ContextMenuContentMobile.js.map
